<div class="wishListWrapper">

    <div class="contactSales">
        <a routerLink="/contact">Contact Sales</a>
    </div>
    
    <div class="title"  *ngIf="isEmpty()">
        <div  class="label">Wish List Is Empty</div>
    </div>

    <div class="list" *ngIf="authService.profile != null">


        <app-poster-card [movie]="movie" *ngFor="let movie of authService.profile.wishListMovies "></app-poster-card>
    </div>
</div>
 